/**
 * Input.js
 *
 * Copyright (c) apploft. GmbH
 */
import React from 'react';
import { stringMatching, isRequired } from '../Theme';

function Input(_ref) {
  var name = _ref.name,
      props = _ref.props,
      errors = _ref.errors,
      register = _ref.register,
      type = _ref.type,
      defaultValue = _ref.defaultValue,
      strings = _ref.strings;
  var example = props.example,
      description = props.description;
  var required = isRequired(props);
  return React.createElement(React.Fragment, null, React.createElement('label', null, stringMatching(strings, name, required)), React.createElement('input', {
    type: type,
    name: name,
    ref: register({
      required: required
    }),
    placeholder: example,
    title: description,
    defaultValue: defaultValue
  }), errors[name] && React.createElement('p', null, " ".concat(stringMatching(strings, name), " ").concat(stringMatching(strings, 'required'))));
}

export default Input;